export const SKILL_MAP = {
  1: ['letter_sounds_consonants','letter_sounds_vowels','phonological_awareness_rhyming','print_concepts'],
  2: ['letter_sounds_consonants_mastery','letter_sounds_vowels_mastery','phonological_awareness_rhyming','print_concepts'],
  3: ['cvc_blending','initial_sound_isolation','final_sound_isolation','basic_sight_words'],
  4: ['cvc_blending_fluency','initial_sound_isolation','final_sound_isolation','basic_sight_words_mastery'],
  5: ['consonant_blends','digraphs','cvce_pattern','sight_words_dolch'],
  6: ['consonant_blends_mastery','digraphs_mastery','vowel_teams','fluency_cvc'],
  7: ['cvce_pattern_mastery','vowel_teams','fluency_cvc','sight_words_dolch_mastery'],
  8: ['syllable_division','prefixes','suffixes','root_words_latin','multisyllabic_decoding','comprehension_literal'],
  9: ['prefixes_mastery','suffixes_mastery','root_words_greek','multisyllabic_decoding','comprehension_inferential'],
  10: ['root_words_latin_mastery','root_words_greek','comprehension_literal_mastery','comprehension_inferential'],
  11: ['syllable_division_mastery','multisyllabic_decoding_mastery','comprehension_inferential_mastery'],
  12: ['figurative_language','text_evidence','academic_vocabulary'],
  13: ['figurative_language_applied','argument_evaluation','academic_vocabulary_applied'],
  14: ['text_evidence_mastery','argument_evaluation','critical_analysis'],
  15: ['figurative_language_mastery','critical_analysis','academic_vocabulary_mastery']
};

export const MODE_SKILLS = {
  phonics: {1:'letter_sounds_consonants',2:'letter_sounds_consonants_mastery',3:'cvc_blending',4:'cvc_blending_fluency',5:'consonant_blends',6:'digraphs_mastery',7:'cvce_pattern_mastery',8:'syllable_division',9:'multisyllabic_decoding',10:'root_words_latin_mastery',11:'syllable_division_mastery',12:'academic_vocabulary',13:'academic_vocabulary_applied',14:'critical_analysis',15:'academic_vocabulary_mastery'},
  sight: {1:'print_concepts',2:'print_concepts',3:'basic_sight_words',4:'basic_sight_words_mastery',5:'sight_words_dolch',6:'fluency_cvc',7:'sight_words_dolch_mastery',8:'comprehension_literal',9:'comprehension_inferential',10:'comprehension_literal_mastery',11:'comprehension_inferential_mastery',12:'text_evidence',13:'argument_evaluation',14:'text_evidence_mastery',15:'figurative_language_mastery'},
  stories: {1:'phonological_awareness_rhyming',2:'phonological_awareness_rhyming',3:'initial_sound_isolation',4:'initial_sound_isolation',5:'cvce_pattern',6:'vowel_teams',7:'vowel_teams',8:'comprehension_literal',9:'comprehension_inferential',10:'comprehension_inferential',11:'multisyllabic_decoding_mastery',12:'figurative_language',13:'figurative_language_applied',14:'argument_evaluation',15:'critical_analysis'},
  bubbles: {1:'letter_sounds_vowels',2:'letter_sounds_vowels_mastery',3:'final_sound_isolation',4:'final_sound_isolation',5:'digraphs',6:'consonant_blends_mastery',7:'fluency_cvc',8:'prefixes',9:'prefixes_mastery',10:'root_words_greek',11:'multisyllabic_decoding_mastery',12:'text_evidence',13:'academic_vocabulary_applied',14:'text_evidence_mastery',15:'figurative_language_mastery'}
};

export const BKT_PARAMS = { pT: 0.15, pS: 0.10 };

export function bktPG(mode) { return mode === 'sight' || mode === 'stories' ? 0.33 : 0.25; }

export function bktUpdate(pL, correct, pG, pS) {
  if (correct) {
    const pCK = 1 - pS, pCU = pG;
    return (pL * pCK) / (pL * pCK + (1 - pL) * pCU);
  } else {
    const pWK = pS, pWU = 1 - pG;
    return (pL * pWK) / (pL * pWK + (1 - pL) * pWU);
  }
}

export function bktLearn(posterior, pT) {
  return posterior + (1 - posterior) * pT;
}

export function initBkt(level) {
  const bkt = {};
  for (let lv = 1; lv <= 15; lv++) {
    const skills = SKILL_MAP[lv] || [];
    skills.forEach(sk => {
      if (bkt[sk] !== undefined) return;
      if (lv < level) bkt[sk] = 0.95;
      else if (lv === level) bkt[sk] = 0.5;
      else bkt[sk] = 0.1;
    });
  }
  return bkt;
}

export function getBktLevel(bkt) {
  let mastered = 0;
  for (let lv = 1; lv <= 15; lv++) {
    const skills = SKILL_MAP[lv] || [];
    if (skills.length > 0 && skills.every(sk => (bkt[sk] || 0) >= 0.95)) mastered = lv;
    else break;
  }
  return Math.min(mastered + 1, 15);
}
